import { Middleware } from 'redux';
import { logger } from 'redux-logger';

// Reads `import.meta.env.PROD` rather than `Config.DEBUG` (same value, but
// behind a getter in another module) so Vite can substitute it literally and
// fold the branch — in a production build this array is simply empty and the
// logger is never wired into the store.
//
// redux-logger itself still ends up in the bundle: it is CommonJS, so Vite
// pre-bundles it and Rollup will not tree-shake the module away. That costs a
// few KB of inert code. Removing it entirely would mean making store setup
// async so the import could be dynamic, which is not worth it here.
//
// The cast is needed because @types/redux-logger is written against redux 5's
// UnknownAction while this project is still on redux 4's AnyAction.
export const loggerMiddleware: Middleware[] = import.meta.env.PROD ? [] : [logger as Middleware];
